export default __webpack_public_path__ + "static/media/warning--monkey-crossing--g1.f226862a.png";